import React from "react";
import TlkTable from "../tlelrik/table/tlkTable";
import services from "../../services";
import moment from "moment";
import $ from "jquery";
import TitleBar from "../common/title_bar";
import SearchFilter from "../filters/SearchFilter";


let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 20,
    idEntidade: null
};

const filters = {
    Tabs: {
        NIF: [
            {
                key: "nif",
                displayKey: "procurar por nif",
                inputType: "text",
            },
        ]
    },
    checkbox: [],
}

const fullDateFormat = "DD-MM-YYYY HH:mm:ss";

const dateFormat2 = "DD-MM-YYYY";

let tablesjson = {
        columnkeyMap: {
            tipo: "Tipo",
            assunto: "Assunto",
            dataEnvio: "Data Envio",
            // dataReenvio: "Data Último Reenvio",
            entidade: "Entidade Origem",
            utilizador: "Utilizador"
        },
        actionbuttons: {notAction: true,},
        listApilink: "Transversal/ViewNotificacoes",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de notificações",
        Filters: {
       
        },
        // groupfield: [{ field: "Utilizador" }],
        groupfield: [],
}


class NotificacoesGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: tablesjson,
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error: null,
            showSearchMsg: false,
            totalcount: 0,
            invoice: null
        };
    }

    componentDidMount() {
        this.defaultState();
    }

    componentDidUpdate = (preProp) => {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
         
            this.defaultState();
        }
    };

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson;
        this.setState(
            {
                linkData: linkData,
                tlkState: {
                    take: 20,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
            }
        );
    };

    handleFilter = (data) => {
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    };

    getFilters = (customfilters) => {
        let applyedfilter = {
            ...customfilters.filterCheckbox,
            ...customfilters.filters,
        };
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem("Local");
        console.log("filter", applyedfilter);
        this.setState(
            {
            applyedfilter,
            date: new Date(),
            },
            () => this.getListData()
        );
    };

    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter };
        
        if (
            Request.Filters.entityId === undefined ||
            Request.Filters.entityId === ""
        ) {
            Request.Filters.entityId = null;
        }
        if (
            Request.Filters.entityname === undefined ||
            Request.Filters.entityname === ""
        ) {
            Request.Filters.entityname = null;
        }
        if(this.props.tableName === "FiscInsercaoSelosEtiquetas"){
           
           Request.idEntidade = Request.Filters.entityIdFilter
            
        }
        return Request;
    };

    getListData = async () => {
        try {
            if (!this.state.linkData) return;
            let Request = {NIFEntidade : this.state.applyedfilter.entityIdFilter}
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,
                });
            }
            
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("columnkeyMap -> ", columnkeyMap);
            console.log("Object.keys(columnkeyMap) -> ", Object.keys(columnkeyMap));
            let res = {};
    
            res = await services.apiCall.requestApi(link, Request, method);
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "dataEnvio") {
                            _row[columnkeyMap[key]] = _row.dataEnvio
                                ? moment(_row.dataEnvio).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        }else if (key === "dataReenvio") {
                            _row[key] = _row.dataEntrega
                                ? moment(_row.dataReenvio).format(
                                    dateFormat2
                                  )
                                : "nd";
                        }  else{
                            _row[columnkeyMap[key]] = _row[key] || "";
                        }
                       
                    });
                });
                window.localStorage.setItem('table_total', res.length);
                this.setState(
                    {
                        data: res,
                        filterData: res,
                        showSearchMsg: false,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => {
                        this.createTabel();
                    }
                );
            } else {
                this.setState({
                    showSearchMsg: true,
                    totalcount: 0,
                    telkikTable: null,
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };
    // expandChange = (event) => {
    //     console.log(event)
    //   };

    createTabel = () => {
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    list={this.state.filterData}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    columnlist={columnlist}
                    notAction={true}
                    actionbuttons={actionbuttons}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                    groupfield={this.state.linkData.groupfield}
                    collepsview={true}
                    viewFor={"notificacoes"}
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    tableFilters = (tlfilter) => {
        try {
            
            let tlkState = { ...tlfilter };
            
            let linkData = { ...this.state.linkData };

            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        return data;
    };

    ActionPerform = (action, row) => {
        if (action == "Edit") {
            window.location.href = `/frases_detail?&id=${encodeURIComponent(row.idTipoReprovacaoEncrypt)}`
        }
    };

    handleDesbloquear = async (row) => { 
        console.log(row)
        let data = {
            idAuto : row.idAuto

        };
        console.log(data , "dados no submit")
        let res = await services.apiCall.requestApi(
            "Fiscalizacao/DesbloquearRS",
            data,
            "post"
        );
    };

    b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 0;
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
  }

    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        topBarMenu={this.props.topBarMenuOption}
                        // path={"/frases_detail"}
                        title="Notificações"
                        logo="auditing"
                    />
                   <SearchFilter
                        searchplaceholder="Pesquisa por NIF ou designação"
                        installationNumber={true}
                        filters={filters}
                        moduleType="Conta"
                        data={this.state.data}
                        handleFilter={(data) => this.handleFilter(data)}
                        getFilter={(data) => this.getFilters(data)}
                    />
                    <br></br>
                    <div className="table-responsive table-section">
                        {/* <h3>
                            {" "}
                            A pesquisa retornou {this.state.totalcount}{" "}
                            resultados{" "}
                        </h3> */}
                        {this.state.telkikTable}
                    </div>
                </div>
            </div>
        );
    }
}

export default NotificacoesGrid;
